module.exports = __webpack_public_path__ + "img/mark2.3e3f5816.png";